"use strict";

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Contains sync list item information.
 *
 * @property {string} channel_sid Channel sid
 * @property {string} channel Channel entity name
 * @property {string} messages Channel messages entity name
 * @property {string} roster Channel roster entity name
 * @property {Number} lastConsumedMessageIndex Index of the last Message the User has consumed in this Channel
 * @property {Channel.Status} status Whether Client is 'invited' to or is 'joined' to this Channel

 */

var SyncListDescriptor =
/**
 * @param {Object} sync list descriptor data object
 * @private
 */
function SyncListDescriptor(descriptor) {
  (0, _classCallCheck3.default)(this, SyncListDescriptor);

  this.descriptor = descriptor;
  this.channel_sid = descriptor.channel_sid;
  this.status = descriptor.status;
  this.channel = descriptor.channel;
  this.messages = descriptor.messages;
  this.roster = descriptor.roster;
  this.lastConsumedMessageIndex = descriptor.last_consumed_message_index;
  this.status = descriptor.status;
};

exports.SyncListDescriptor = SyncListDescriptor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/twilio-chat/browser/synclistdescriptor.js
// module id = ./node_modules/twilio-chat/browser/synclistdescriptor.js
// module chunks = 0